const styles = (theme) => ({
  title: {
    color: theme.palette.common.blue400,
    width: '100%',
    textAlign: 'center',
    marginBottom: 40,
    fontSize: 40,
    '@media(max-width: 600px)': {
      fontSize: theme.typography.fontSize24,
      marginBottom: 20,
      textAlign: 'start',
    },
  },
  card: {
    height: '100%',
    boxShadow: 'none',
    backgroundColor: theme.palette.common.white,
  },
  content: {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    textAlign: 'center',
    color: theme.palette.common.white,
    width: 'fit-content',
    columnGap: 40,
    flexWrap: 'wrap',
    '&:last-child': {
      paddingBottom: 0,
    },
    '@media(max-width: 600px)': {
      justifyContent: 'flex-start',
    },
  },
  file: {
    width: 360,
    backgroundColor: '#f3f3f3',
    borderRadius: 20,
    padding: '10px 15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.text.primary,
    marginBottom: 24,
    '&:last-child': {
      marginBottom: 0,
    },
    '@media(max-width: 600px)': {
      maxWidth: 270,
      width: 'max-content',
    },
  },
  fileName: {
    fontSize: theme.typography.fontSize16,
    lineHeight: 1.5,
    textAlign: 'left',
  },
  downloadIcon: {
    cursor: 'pointer',
    marginLeft: 16,
    width: 24,
    '& > img': {
      maxWidth: 26,
    },
  },
});

export default styles;
